const STORAGE_PREFIX = 'oms-supplier-invite-progress:'
const HISTORY_PREFIX = 'oms-supplier-invite-history:'

/** Minimum gap between resends for the same venue (ms). */
export const INVITE_RESEND_COOLDOWN_MS = 60 * 1000

/**
 * Session-only record of the last invitation attempt for a venue.
 * Used so progress UI does not invent history for older customers.
 */
export const saveInviteProgressAttempt = (venueId, attempt) => {
  if (!venueId || typeof sessionStorage === 'undefined') return
  const record = {
    ...attempt,
    at: attempt.at || new Date().toISOString(),
  }
  try {
    sessionStorage.setItem(
      `${STORAGE_PREFIX}${venueId}`,
      JSON.stringify(record),
    )
    appendInviteHistory(venueId, record)
  } catch (err) {
    console.warn('Could not save invite progress attempt', err)
  }
}

export const readInviteProgressAttempt = venueId => {
  if (!venueId || typeof sessionStorage === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${venueId}`)
    if (!raw) return null
    return JSON.parse(raw)
  } catch (err) {
    return null
  }
}

const appendInviteHistory = (venueId, record) => {
  try {
    const key = `${HISTORY_PREFIX}${venueId}`
    const existing = JSON.parse(sessionStorage.getItem(key) || '[]')
    const next = Array.isArray(existing) ? existing : []
    next.push({
      at: record.at,
      email: record.email,
      emailDispatch: record.emailDispatch,
      journey: record.journey,
      resent: Boolean(record.resent),
    })
    // Keep last 10 attempts only
    sessionStorage.setItem(key, JSON.stringify(next.slice(-10)))
  } catch (err) {
    // ignore history failures
  }
}

export const readInviteHistory = venueId => {
  if (!venueId || typeof sessionStorage === 'undefined') return []
  try {
    const raw = sessionStorage.getItem(`${HISTORY_PREFIX}${venueId}`)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch (err) {
    return []
  }
}

/**
 * @returns {{ allowed: boolean, waitSeconds: number, lastAt: string|null }}
 */
export const getInviteResendGate = (
  venueId,
  cooldownMs = INVITE_RESEND_COOLDOWN_MS,
) => {
  const last = readInviteProgressAttempt(venueId)
  if (!last?.at) {
    return { allowed: true, waitSeconds: 0, lastAt: null }
  }
  // Failed hand-offs must not block an immediate retry
  if (last.emailDispatch === 'failed') {
    return { allowed: true, waitSeconds: 0, lastAt: last.at }
  }
  const elapsed = Date.now() - new Date(last.at).getTime()
  if (Number.isNaN(elapsed) || elapsed >= cooldownMs) {
    return { allowed: true, waitSeconds: 0, lastAt: last.at }
  }
  const waitSeconds = Math.max(1, Math.ceil((cooldownMs - elapsed) / 1000))
  return { allowed: false, waitSeconds, lastAt: last.at }
}
